export const EXTERNAL_ACCOUNT_SET_ACCOUNT = "EXTERNAL_ACCOUNT_SET_ACCOUNT";
export const EXTERNAL_ACCOUNT_SET_TIMING_OUT =
  "EXTERNAL_ACCOUNT_SET_TIMING_OUT";
export const EXTERNAL_ACCOUNT_SET_TIMED_OUT = "EXTERNAL_ACCOUNT_SET_TIMED_OUT";
export const EXTERNAL_ACCOUNT_RESET = "EXTERNAL_ACCOUNT_RESET";

export const setExternalAccount = (account) => {
  return {
    type: EXTERNAL_ACCOUNT_SET_ACCOUNT,
    account,
  };
};

export const setExternalAccountTimingOut = (payload) => ({
  type: EXTERNAL_ACCOUNT_SET_TIMING_OUT,
  payload,
});

export const setExternalAccountTimedOut = (payload) => ({
  type: EXTERNAL_ACCOUNT_SET_TIMED_OUT,
  payload,
});

export const resetExternalAccountState = () => ({
  type: EXTERNAL_ACCOUNT_RESET,
});
